module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Winter Ball")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("By Amy Lane")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Through a miserable adolescence and a lonely adulthood, Skipper Keith has dreamed of nothing but family. The closest he gets is the rec league soccer team he coaches after work—and his star player and best friend, Richie Scoggins.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("One brisk night in late October, a postpractice convo in Richie’s car turns into a sexual encounter neither of them expected—nor want to forget. Soon Skip and Richie are living for the weekends and their winter league soccer games—and the games they enjoy off the field. Through broken noses, holiday decorating, and the killer flu, they learn more about each other than they ever dreamed possible. Every new discovery takes them further beyond the boundaries of the soccer field and into the infinite possibilities of the best relationship of Skipper’s life. ")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Skipper can’t dream of a better family than Richie—but Richie’s got real family entanglements he can’t shake off. Skipper needs to convince Richie to stay with him beyond winter ball so the relationship they started on the field might become their happy future in real life!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6328bbc1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0002.vue
// module id = 60
// module chunks = 0